import { SEARCH_CHANGED, SEARCH_LOGOUT } from "../../const/actionsType";
import { dates } from "investira.sdk";

const INITIAL_STATE = {
  pesquisa: "",
  result: {},
  pages: {},
  updatedAt: dates.toDate(),
};

function searchAtivosReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SEARCH_CHANGED:
      return {
        ...state,
        ...action.payload,
      };
    case SEARCH_LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default searchAtivosReducer;
